import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, ShieldAlert } from "lucide-react";
import Layout from "@/components/Layout";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="animate-spin text-sky-500" size={32} />
      </div>
    );
  }

  if (user === false) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(user.role)) {
    return (
      <Layout>
        <div className="max-w-lg mx-auto mt-16 text-center site-card p-10 rounded-lg" data-testid="access-denied">
          <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center text-red-600">
            <ShieldAlert size={28} />
          </div>
          <div className="text-red-600 font-black text-2xl mb-2 font-display">Erişim Reddedildi</div>
          <div className="text-slate-600">Bu sayfayı görüntülemek için yetkiniz bulunmuyor. Sol menüden erişebileceğiniz alanlara geçiş yapabilirsiniz.</div>
        </div>
      </Layout>
    );
  }

  return children;
}
